var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "80px",
    viewBox: "0 0 98 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-373.000000, -80.000000)",
    fill: "#F64242"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8544414,80 C83.3659825,71.9730145 93.0473021,65.1262799 98.8984003,59.4597962 C109.052982,49.6256124 118.708883,37.96492 118.708883,23.3162029 C118.708883,9.48987043 112.598656,1.71420124 98.8984003,0.128454582 C89.7648964,-0.928709858 80.0704049,4.53936971 69.8149258,16.5326933 C58.0550862,4.53936971 47.8266952,-0.928709858 39.1297528,0.128454582 C26.0843393,1.71420124 21,9.90359982 21,23.3162029 C21,37.7777681 29.2713959,49.6905292 39.1297528,59.4597962 C44.9687308,65.2460073 55.2102936,72.0927419 69.8544414,80 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.238d5edf02651f1a9ac51a87b757aae5.svg";
export { ForwardRef as ReactComponent };